import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  order: {
    columnId: null,
    reverse: true
  },
  filter: [],
  report: null,
  reports: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
